import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 25% 50%, oklch(var(--primary-500)) 1px, transparent 1px), radial-gradient(circle at 75% 30%, oklch(var(--accent-500)) 1px, transparent 1px)',
          backgroundSize: '60px 60px, 80px 80px',
        }}
      />

      <div className="absolute top-[-200px] right-[-100px] w-[600px] h-[600px] rounded-full opacity-[0.06] pointer-events-none"
        style={{ background: `radial-gradient(circle, oklch(var(--primary-500)), transparent 70%)` }}
      />

      <div className="absolute bottom-[-100px] left-[-50px] w-[400px] h-[400px] rounded-full opacity-[0.04] pointer-events-none"
        style={{ background: `radial-gradient(circle, oklch(var(--accent-500)), transparent 70%)` }}
      />

      <div className="w-full px-4 md:px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-24 lg:pt-0">
            <span className="inline-block px-3 py-1.5 rounded-full bg-primary-500/15 text-primary-400 text-xs md:text-sm font-medium mb-5 whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-50 leading-tight mb-3 font-heading">
              {heroData.h1}
            </h1>

            <p className="text-lg md:text-xl text-foreground-400 font-medium mb-5 font-heading">
              {heroData.slogan}
            </p>

            <p className="text-foreground-400 text-sm md:text-base leading-relaxed max-w-2xl lg:max-w-none mb-6">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-7">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-400 font-heading">{stat.value}</div>
                  <div className="text-xs text-foreground-600 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-medium rounded-md text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-rocket-line"></i>
                {heroData.primaryCta.text}
              </a>
              <a
                href={heroData.secondaryCta.href}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-200 hover:bg-background-300 text-foreground-200 font-medium rounded-md text-sm transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-400/50"
              >
                <i className="ri-timer-line"></i>
                {heroData.secondaryCta.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-lg">
              <div className="absolute inset-0 rounded-xl opacity-40 blur-3xl pointer-events-none"
                style={{ background: `radial-gradient(circle, oklch(var(--primary-500) / 0.3), transparent 70%)` }}
              />
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20composition%20with%20red%20and%20black%20dynamic%20shapes%2C%20journalism%20and%20investigation%20theme%2C%20spotlight%20effect%20on%20dark%20stage%2C%20mysterious%20competitive%20atmosphere%2C%20editorial%20design%20style%2C%20high%20contrast%20artistic%20photography%2C%20no%20text%2C%20cinematic%20mood&width=1000&height=800&seq=hero-main-01&orientation=portrait"
                alt="每日大赛黑料 - 全网赛事内幕第一站"
                className="relative w-full h-auto max-h-[500px] object-cover rounded-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}